import instance from './axiosInstance';

const url = '/change_log';

export const getLogs = (type, http = instance, options = {}) => http.get(`${url}/?type=${type}`, options);

export const getLog = (id, http = instance, options = {}) => http.get(`${url}/${id}`, options);
